// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const AuthSection = require('../containers/auth-section/component-smart')

const bem = BemEntity('DeviceSection')

function DeviceSection() {
  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('inner')
      },
        tag('div', {
          className: bem.element('image-wrapper')
        },
          tag('div', {
            className: bem.element('image-desktop')
          }),
          tag('div', {
            className: bem.element('image-mobile')
          })
        ),
        tag('div', {
          className: bem.element('text-wrapper')
        },
          tag('div', {
            className: bem.element('title')
          },
            `Unlock the internet.`
          ),
          tag('div', {
            className: bem.element('subtitle')
          },
            `Browse the corners of the internet your other social feeds skip over.
            Get Mix on your phone and find paths you didn’t know you were looking for.`
          ),
          tag(AuthSection)
        )
      )
    )
  )
}

module.exports = DeviceSection
